import React from "react";

function IconIntelligentPricing() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2a.75.75 0 01.666.405l2.512 4.845h3.072a.75.75 0 010 1.5h-2.294l3.71 7.155A.75.75 0 0117 17H3a.75.75 0 01-.666-1.095l3.71-7.155H3.75a.75.75 0 010-1.5h3.072l2.512-4.845A.75.75 0 0110 2zM7.734 8.75l-3.5 6.75h11.532l-3.5-6.75H7.734zm3.755-1.5H8.51L10 4.38l1.489 2.87z"
      />
    </svg>
  );
}

export default IconIntelligentPricing;
